import { render, staticRenderFns } from "./CaseOverviewCard.vue?vue&type=template&id=1cf87a64&scoped=true&"
import script from "./CaseOverviewCard.vue?vue&type=script&lang=js&"
export * from "./CaseOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseOverviewCard.vue?vue&type=style&index=0&id=1cf87a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf87a64",
  null
  
)

export default component.exports